export default str => {
  if (typeof str !== 'string' || !str) {
    return undefined;
  }
  const arr = (str || '')
    .split(',')
    .map(value => value.replace(/^\s+|\s+$/g, ''))
    .filter(value => value);
  return arr.length ? arr : undefined;
};
